export const male_hair = [ //An array of each Male hairstyle's ID, Atlas file, and name. There are 26.
  {
    id: 'hair1', //For hairstyles, append #vb_ to find id of div. 
    atlas: 'atlas17', //Append to atlas to find class.
    name: 'Tunnel Snake' //Show name in textbox.
    /* Alternatively 'Professor'. */
  },
  {
    id: 'hair2',
    atlas: 'atlas17',
    name: '#2' 		/* NAME ME!! */
  },
  {
    id: 'hair3',
    atlas: 'atlas17',
    name: 'Clean Cut?'
  },
  {
    id: 'hair4',
    atlas: 'atlas17',
        name: 'Also Smooth Wave?'    /* HairWavy , Alternatively Rebel. */
  },
  {
    id: 'hair5',
    atlas: 'atlas17',
    name: 'Sarge?' /* Alternatively 'Urban Ranger'. */    /* This hair is unisex. */
  },
  {
    id: 'hair6',
    atlas: 'atlas17',
    name: 'Shaggy Suave?'
  },
  {
    id: 'hair7',
    atlas: 'atlas17',
    name: 'Garage Band?'
  },
  {
    id: 'hair8',
    atlas: 'atlas17',
    name: '#8' 		/* NAME ME!! */
  },
  {
    id: 'hair10',
    atlas: 'atlas17',
    name: 'Warhawk?'
  },
  {
    id: 'hair9',
    atlas: 'atlas17',
    name: 'Combover?'
  },

  {
    id: 'hair11',
    atlas: 'atlas17',
    name: 'Waster?'
  },
  {
    id: 'hair12',
    atlas: 'atlas17',
    name: 'Also Smooth Wave?'		 /* HairWavy */
  },
  {
    id: 'hair13',
    atlas: 'atlas17',
    name: '#13'		 /* NAME ME!! */
  },
  {
    id: 'hair14',
    atlas: 'atlas17',
    name: 'Beatnik?'
  },
  {
    id: 'hair15',
    atlas: 'atlas17',
    name: 'Dapper?'
  },
  {
    id: 'hair16',
    atlas: 'atlas17',
    name: '#16'		 /* NAME ME!! */
  },
  {
    id: 'hair17',
    atlas: 'atlas17',
    name: 'Colonial?'
  },
  {
    id: 'hair18',
    atlas: 'atlas17',
    name: 'Buzzcut?' /* Alternatively 'Heavyweight'. */
  },
  {
    id: 'hair19',
    atlas: 'atlas17',
    name: '#19' /* Alternatively 'Heavyweight'. */
  },
  {
    id: 'hair20',
    atlas: 'atlas17',
    name: '#20' /* Alternatively 'Heavyweight'. */
  },
  {
    id: 'hair21',
    atlas: 'atlas17',
    name: 'Also Dapper?' /* Alternatively 'Pompadour'. */
  },
  {
    id: 'hair22',
    atlas: 'atlas17',
    name: 'Dapper' /* Alternatively 'Pompadour'. */
  },
  {
    id: 'hair23',
    atlas: 'atlas17',
    name: 'Heavyweight' /* Alternatively 'Bootcamp'. */
  },
  {
    id: 'hair25',
    atlas: 'atlas17',
    name: 'Casual Kempt?'
  },
  {
    id: 'hair24',
    atlas: 'atlas17',
    name: 'Bad Hair Day?'
  },
  {
    id: 'hair26',
    atlas: '',
    name: 'Balding' /* HairBalding */
  }
];